<template>
  <div>
    <!-- 저장하기 -->
    <div id="non-sticky" class="flex-align space-between" style="margin: 12px 0">
      <div v-if="isMartAndPartner" style="color:#ff0000">※ 이 상품은 슈퍼바이저가 등록하고 관리하는 상품으로서, 재고만 수정할 수 있습니다. 그 외 내용 수정은 슈퍼바이저에게 문의해 주시기 바랍니다.</div>
      <div v-else></div>
      <div class="flex-align" style="gap: 10px; flex-wrap: wrap">
        <!-- 상품 주문/전환 퍼포먼스 정보 -->
        <btn-product-order-performance v-if="is_modify"
          :prod="prod" :performance="performance"
          :productType="productType"
          :conversion="conversion"
          :disabled="isMartAndPartner"></btn-product-order-performance>
        <button v-if="$route.query.id && $route.query.id !== ''" class="button is-gray" @click="showProduct">상품 미리보기</button>
        <button v-if="isMobile || (!isMobile && prodTab === 0)" class="button is-primary" @click="saveData">저장하기</button>
      </div>
    </div>
    <div id="sticky" style="display: none">
      <div class="flex-align fixed">
        <span class="level-title" style="flex: 1">
          <strong class="flex-align">{{ computedMenuName }}</strong>
        </span>
        <div class="flex-align" style="gap: 0 10px">
          <btn-product-order-performance v-if="is_modify"
            :prod="prod" :performance="performance"
            :productType="productType"
            :conversion="conversion"
            :disabled="isMartAndPartner"></btn-product-order-performance>
          <button v-if="$route.query.id && $route.query.id !== ''" class="button is-gray" @click="showProduct">상품 미리보기</button>
          <button v-if="prodTab === 0" class="button is-primary" @click="saveData">저장하기</button>
        </div>
      </div>
    </div>

    <div :style="{height: isFixed ? '50px' : '0px'}"></div>
    <template v-if="prodTab === 0">
      <div class="detector"></div>
      <div class="columns is-multiline">
        <!-- 왼쪽 레이아웃 -->
        <div class="column is-7">

          <!-- 상품 종류 선택 -->
          <div class="box" v-if="enablePanel('panel1')">
            <admin-box-item title="상품종류 선택"
                            tip="카테고리 관리 페이지에서 등록한 상품 종류가 노출됩니다. 등록하고자 하는 상품 종류를 선택해주세요.

                                  *해당 카테고리에 포함되지 않은 상품 종류(팩)은 등록할 수 없으며, 하나의 상품에 두개 이상의 상품 종류를 선택할 수 없습니다."
                            :showToggleButton="true"
                            :titleFlex="true"
                            justifyContent="space-between"
                            :disabled="isMartAndPartner">
              <template #title>
                <button class="button flex-center text-primary modify-btn"
                        @click="modifyCategory">
                  <i class="material-icons-outlined text-primary" style="font-size: 16px">edit</i>
                  <div class="size-13 weight-400">편집</div>
                </button></template>
              <!-- <button slot="header-right-spot"
                class="button text-primary size-20"
                @click.stop.prevent="modifyCategory"
                style="margin-right: 60px">상품종류 수정</button> -->
              <template v-for="item in packages">
                <div class="lp-package-button unselect"
                     :key="'package-'+item.id"
                     :class="{'package-selected':selectedPack && item.id===selectedPack.id}"
                     @click="selectPackage(item)">
                  {{ item.kor_name }}</div>
              </template>
            </admin-box-item>
          </div>

          <!-- 상품 카테고리 -->
          <a id="sb_category"></a>
          <div class="box tab-item">
            <admin-box-item title="카테고리 선택*"
                            :tip="'상품이 노출될 카테고리를 선택합니다.\n\n'+
                    '카테고리 선택 시 카테고리 관리 페이지에서 매핑한 카테고리와 상품종류가 짝지어 나타납니다.'"
                            :disabled="isMartAndPartner">
              <template #title>
                <button class="button flex-center text-primary modify-btn"
                        @click="routerPush('/office/admin/category/create')">
                  <i class="material-icons-outlined text-primary" style="font-size: 16px">edit</i>
                  <div class="size-13 weight-400">편집</div>
                </button>
              </template>
              <div class="columns is-multiline" v-if="catArr1.length>0">
                <div class="column is-full">
                  <lp-adm-drop-input ref="adminput_prod"
                                     :data.sync="catArr1"
                                     :selectVal="selectedCategory(prod.category1_id, 'cat1')"
                                     @onSelect="res => clickCategory(res.value, 'cat1')"
                                     placeholder="1차 카테고리"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

                  <lp-adm-drop-input ref="adminput_prod"
                                     :data.sync="cat2"
                                     :selectVal="selectedCategory(prod.category2_id, 'cat2')"
                                     @onSelect="res => clickCategory(res.value, 'cat2')"
                                     placeholder="2차 카테고리"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

                  <lp-adm-drop-input ref="adminput_prod"
                                     :data.sync="cat3"
                                     :selectVal="selectedCategory(prod.category3_id, 'cat3')"
                                     @onSelect="res => clickCategory(res.value, 'cat3')"
                                     placeholder="3차 카테고리"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:12px;"></lp-adm-drop-input>
                  <!-- <button class="button text-primary"
                    @click="routerPush('/office/admin/category/create')">카테고리 편집</button> -->
                </div>
              </div>
            </admin-box-item>
          </div>
          <!-- 주문 전환 방식 -->
          <template v-if="enablePanel('panel2') && this.prod.category1_id">
            <a id="sb_inquiry_conversion"></a>
            <div class="box tab-item">
              <admin-box-item :title="conversionTitle" :disabled="isMartAndPartner" :showToggleButton="true">
                <admin-form-item label="문의 전환" desc="상품에 지정한 파트너의 연락처, 이메일로 문의가 연결됩니다.">
                  <lp-radio :val.sync="prod.inquiry_conversion_type"
                            value_name="value"
                            label_name="label"
                            :data="inquiryConversionArr"></lp-radio>
                </admin-form-item>
                <!--<admin-form-item label="주문 전환" desc="주문 받고 싶은 유형을 선택합니다.">
                  <lp-radio :val.sync="prod.order_conversion_type"
                            value_name="value"
                            label_name="label"
                            :data="order_conversion_arr"></lp-radio>
                </admin-form-item>-->
                <admin-form-item label="결제방식"
                                 v-if="[0,1,2,5,6].indexOf(prod.order_conversion_type) === -1">
                  <lp-radio :val.sync="prod.payment_type"
                            value_name="value"
                            label_name="label"
                            :data="paymentTypeArr"></lp-radio>
                </admin-form-item>
                <div v-else style="height:46px"></div>
                <template v-if="['reservation','booking'].indexOf(prod.package)>-1">
                  <admin-form-item label="예약 승인방식">
                    <lp-radio :val.sync="prod.auto_resv_status"
                            value_name="value"
                            label_name="label"
                            :data="autoStatusArr"></lp-radio>
                  </admin-form-item>
                </template>
              </admin-box-item>
            </div>
          </template>
          <!-- SNS 문의 전환 설정 -->
          <template v-if="isInternalPlugin('sns_inquiry')">
            <a id="sb_sns_inquiry"></a>
            <div class="box tab-item" v-if="isInternalPlugin('sns_inquiry')">
            <admin-box-item title="SNS 문의 전환 설정" subtitle="파트너에게 문의할 수 있는 SNS 채널을 선택하고 링크를 입력합니다.">
              <admin-form-item label="SNS 채널">
                <lp-radio :val.sync="prod.sns_inquiry_type"
                          value_name="value"
                          label_name="label"
                          :data="[{label:'파트너 SNS 정보와 동일',value:0},{label:'상품별 개별 설정',value:1}]"></lp-radio>
                <div class="columns is-multiline" style="margin-top:12px" v-if="prod.sns_inquiry_type===1">
                  <div class="column is-3">
                    <lp-check-bool :checked-val.sync="prod.enable_naver"
                                   label="네이버블로그"></lp-check-bool>
                    <input class="input"
                           style="margin-top:8px"
                           :value="prod.naver"
                           @input="e => prod.naver = e.target.value"
                           type="text"
                           maxlength="50">
                  </div>
                  <div class="column is-3">
                    <lp-check-bool :checked-val.sync="prod.enable_kakao"
                                   label="카카오톡"></lp-check-bool>
                    <input class="input"
                           style="margin-top:8px"
                           :value="prod.kakao"
                           @input="e => prod.kakao = e.target.value"
                           type="text"
                           maxlength="50">
                  </div>
                  <div class="column is-3">
                    <lp-check-bool :checked-val.sync="prod.enable_instagram"
                                   label="인스타그램"></lp-check-bool>
                    <input class="input"
                           style="margin-top:8px"
                           :value="prod.instagram"
                           @input="e => prod.instagram = e.target.value"
                           type="text"
                           maxlength="50">
                  </div>
                  <div class="column is-3">
                    <lp-check-bool :checked-val.sync="prod.enable_homepage"
                                   label="홈페이지"></lp-check-bool>
                    <input class="input"
                           style="margin-top:8px"
                           :value="prod.homepage"
                           @input="e => prod.homepage = e.target.value"
                           type="text"
                           maxlength="50">
                  </div>
                </div>
              </admin-form-item>
            </admin-box-item>
          </div>
          </template>
          <!-- 상품 기본정보 -->
          <a id="sb_product_basic"></a>
          <div class="box tab-item">
            <admin-box-item title="상품 기본정보" :disabled="isMartAndPartner">
              <div class="columns is-multiline">

                <div class="column is-3" v-if="isInternalPlugin('product_priority')">
                  <admin-form-item label="노출 우선순위">
                    <input class="input"
                           v-model.number="prod.priority"
                           placeholder="노출 우선순위를 입력하세요. (0~99)"
                           type="number">
                  </admin-form-item>
                </div>

                <div class="column is-full"
                    v-if="['admin', 'supervisor'].indexOf($store.getters.mode)>-1 && pack!=='delivery' &&
                    prod.order_conversion_type>=0">
                  <div v-if="prod.package==='mart' && isInternalPlugin('supervisor')" style="margin-bottom: 12px">
                    <panel-super-visor ref="panelSuperVisor" :prod="prod" @IsSuperVisor="res=>prod.is_super_visor=res"></panel-super-visor>
                  </div>
                  <admin-form-item label="파트너*" v-if="!prod.is_super_visor">
                    <lp-adm-drop-input :data.sync="partners"
                                      :selectVal="partnerName"
                                      @onSelect="selectPartnerId"
                                      placeholder="검색 후 선택"
                                      listAlign="left"
                                      width="250px"
                                      style="display:inline-block; margin-right:12px;"></lp-adm-drop-input>
                    <lp-check-bool :checkedVal.sync="isEqualPartner" v-if="partnerName !== ''"
                                  style="margin:8px 0"
                                  label="파트너 정보와 상품 정보가 동일합니다."></lp-check-bool>
                  </admin-form-item>
                </div>
                <div class="column is-full" v-if="isInternalPlugin('product_video')">
                  <admin-form-item label="상품 동영상">
                    <lp-input-video :file.sync="prod.video"></lp-input-video>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="상품 대표 이미지" :desc="getRatio('product_card')">
                    <drag-img-single :img.sync="prod.first_img"></drag-img-single>
                  </admin-form-item>

                  <!--<admin-form-item label="상품 대표 이미지" :desc="getRatio('product_card')">
                    <input-img :url.sync="prod.first_img" :idx="12311112315"></input-img>
                  </admin-form-item>-->
                </div>
                <div class="column is-full">
                  <admin-form-item label="상품 이미지" :desc="getRatio('product_detail_slider')">
                    <!--<input-img-multiple
                              :images.sync="prod.imgs"
                              class="item"></input-img-multiple>-->
                    <drag-img-multiple :imgs.sync="prod.imgs"></drag-img-multiple>
                  </admin-form-item>
                </div>
                <!--<div class="column is-full" v-if="isCommerce">
                  <admin-form-item label="첨부 파일">
                    <input-file :files.sync="prod.files"></input-file>
                  </admin-form-item>
                </div>-->
                <div class="column is-full">
                  <admin-form-item label="상품 노출 여부">
                    <lp-radio :val="prod.enable_prod"
                              value_name="value"
                              label_name="label"
                              :data="[{label:'노출',value:true}, {label:'비노출', value:false}]"
                              @onSelect="onSelectedProdState"></lp-radio>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="상품명*">
                    <input class="input"
                          :value="prod.name"
                          @input="e => prod.name = e.target.value"
                          placeholder="상품명을 입력해주세요."
                          type="text">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="상품 한줄 설명">
                    <input class="input"
                          :value="prod.simple_desc"
                          @input="e => prod.simple_desc = e.target.value"
                          placeholder="상품에 대한 간단한 설명을 하는 곳 입니다."
                          type="text" maxlength="70">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="상품 태그"
                                  desc="상품 태그 생성은 키워드 입력 후 엔터(enter)를 입력하시면 됩니다."
                                  tip="상품 검색 시 키워드로 활용되며, 최대 10개까지 등록 가능합니다.">
                    <lp-input-tag :data="prod.tags"></lp-input-tag>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="상품코드">
                    <input class="input"
                          :value="prod.code"
                          @input="e => prod.code = e.target.value"
                          placeholder="상품코드를 입력해주세요."
                          type="text">
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
          <!-- 숙박예약 -->
          <template v-if="prod.package==='booking'">
            <!-- 정책/편의시설 -->
            <panel-booking-policy ref="bookingPolicy" :prod="prod"></panel-booking-policy>
          </template>
          <!-- 상품 시간 정보 -->
          <!--<panel-product-time ref="productTime"
                              v-if="['meet', 'reservation'].indexOf(prod.package)>-1"
            :operatingTime="partner.company_operating"
            :prod="prod" :prod_schedule="prod_schedule"
            :selectedPack="integerToStringSelectedPack()"></panel-product-time>-->
          <!-- 위치 정보 -->
          <template>
            <a id="sb_location"></a>
            <panel-product-location ref="location" :prod="prod"></panel-product-location>
          </template>

          <!-- 맞춤 DB -->
          <template v-if="enablePanel('panel3') && prod_param && prod_param.length>0">
            <a id="sb_custom_db"></a>
            <div class="box">
              <admin-box-item title="맞춤 DB" :disabled="isMartAndPartner" :showToggleButton="true">
                <div class="columns is-multiline">
                  <div class="column is-full"
                      v-for="(param, index) in prod_param"
                      v-bind:key="'param_input'+index">
                    <admin-form-item :label="param.name">
                      <input-param :param.sync="param"></input-param>
                    </admin-form-item>
                  </div>
                </div>
              </admin-box-item>
            </div>
          </template>

          <!-- 시간 예약 -->
          <template v-if="prod.package==='reservation'">
            <!-- 예약 마감시간 -->
            <a id="sb_reserve_deadline"></a>
            <panel-reserve-deadline :reservePolicy="reservePolicy"></panel-reserve-deadline>
          </template>
        </div>

        <!-- 오른쪽 레이아웃 -->
        <div class="column is-5">
          <product-preview v-if="enablePreview" :prod="prod"></product-preview>

          <!-- 전화연결  -->
          <div class="box" v-if="prod.order_conversion_type === 1">
            <admin-box-item title="전화번호 연결">
              <admin-form-item label="전화번호">
                <input class="input"
                      style="display: inline-block;margin-right:12px;width:250px;"
                      :value="prod.phone"
                      @input="e => prod.phone = e.target.value"
                      placeholder="010-1234-5678"
                      type="text"
                      maxlength="13"
                      :disabled="isEqualPartnerPhone">
                <lp-check-bool v-if="partner_id>0" :checkedVal.sync="isEqualPartnerPhone" style="margin-top:12px"
                              label="파트너 대표번호와 동일합니다."></lp-check-bool>
              </admin-form-item>
            </admin-box-item>
          </div>

          <!-- 아웃링크 -->
          <div class="box" v-if="prod.order_conversion_type === 2">
            <admin-box-item title="아웃링크">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="아웃링크 사용 여부">
                    <lp-radio :val.sync="prod.enable_link"
                              value_name="value"
                              label_name="label"
                              :data="[{label:'사용',value:true},{label:'플랫폼 내 주문',value:false}]"></lp-radio>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="연결할 url">
                    <input class="input"
                          v-model="prod.link"
                          @input="e => prod.link = e.target.value"
                          placeholder="https://www.launchpack.co.kr"
                          type="text">
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>

          <!-- 모임신청 -->
          <div class="box" v-if="prod.order_conversion_type === 4">
            <admin-box-item title="모임신청">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="모임신청 사용 여부">
                    <lp-radio :val.sync="prod.enable_meet"
                              value_name="value"
                              label_name="label"
                              :data="[{label:'사용',value:true},{label:'미사용',value:false}]"></lp-radio>
                  </admin-form-item>
                </div>
                <div class="column is-full" v-if="prod.enable_meet">
                  <admin-form-item label="신청 받을 폼 선택">
                    <span class="select">
                      <select v-model="prod.meet_form"
                              @change="e=> prod.meet_form_id = e.target.value">
                        <option value="" disabled selected>신청 받을 폼 선택</option>
                        <option v-for="form in meetFormArr"
                                :key="'form' + form.value"
                                :value="form.value">{{ form.label }}</option>
                      </select>
                      </span>
                  </admin-form-item>
                </div>
                <div class="column is-full" v-if="prod.enable_meet">
                  <admin-form-item label="모임 신청시 문자 메시지">
                    <textarea class="textarea"
                              rows="3"
                              cols="3"
                              placeholder="60자 내외로 작성바랍니다."
                              maxlength="60"
                              v-model="prod.req_msg"></textarea>
                  </admin-form-item>
                </div>
                <div class="column is-full" v-if="prod.enable_meet">
                  <admin-form-item label="모임 신청 확인시 문자 메시지">
                    <textarea class="textarea"
                              rows="3"
                              cols="3"
                              placeholder="60자 내외로 작성바랍니다."
                              maxlength="60"
                              v-model="prod.res_msg"></textarea>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>

          <!-- 상담신청 -->
          <div class="box" v-if="prod.order_conversion_type === 5">
            <admin-box-item title="상담신청">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="상담신청 사용 여부">
                    <lp-radio :val.sync="prod.enable_counsel"
                              value_name="value"
                              label_name="label"
                              :data="[{label:'사용',value:true},{label:'미사용',value:false}]"></lp-radio>
                  </admin-form-item>
                </div>
                <div class="column is-full" v-if="prod.enable_counsel">
                  <admin-form-item label="신청 받을 폼 선택">
                    <span class="select">
                      <select v-model="prod.counsel_form"
                              @change="e=> prod.counsel_form_id = e.target.value">
                        <option value="" disabled selected>신청 받을 폼 선택</option>
                        <option v-for="form in counselFormArr"
                                :key="'form' + form.value"
                                :value="form.value">{{ form.label }}</option>
                      </select>
                      </span>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>

          <!-- 가격 정보 -->
          <template v-if="['reservation','booking'].indexOf(prod.package) === -1 && prod.category1_id !== ''">
            <panel-product-price ref="productPrice"
              :prod="prod" :panel="panel" @calcPrice="calcPrice()"
              :disabled="isMartAndPartner"
              :prod_price="prod_price"></panel-product-price>
          </template>

          <!-- 본인(성인)인증 여부 -->
          <a id="sb_verify" v-if="isInternalPlugin('age_verify') || isInternalPlugin('identity_verify')"></a>
          <div class="box tab-item" v-if="isInternalPlugin('age_verify') || isInternalPlugin('identity_verify')">
            <admin-box-item :title="verifyTitle" :disabled="isMartAndPartner">
              <lp-radio :val.sync="prod.enable_age_verify"
                        value_name="value"
                        label_name="label"
                        :data="[{label:'사용',value:true}, {label:'사용 안 함', value:false}]"></lp-radio>
            </admin-box-item>
          </div>

          <!-- 포인트 적립 설정 -->
          <a id="sb_point_coupon" v-if="isAdmin && enablePanel('panel5') && isInternalPlugin('point_coupon')"></a>
          <div class="box tab-item" v-if="isAdmin && enablePanel('panel5') && isInternalPlugin('point_coupon')">
            <admin-box-item title="포인트 적립 설정" :disabled="isMartAndPartner" :showToggleButton="true">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="포인트 적립 사용여부">
                    <lp-radio :val.sync="prod_price.is_point"
                              value_name="value"
                              label_name="label"
                              :data="[{label:'개별설정',value:true}, {label:'기본설정', value:false}]"></lp-radio>
                  </admin-form-item>
                </div>
                <div v-if="prod_price.is_point">
                  <div class="column is-full">
                    <admin-form-item label="적립 방법">
                      <lp-radio :val.sync="prod_price.point_type"
                                value_name="value"
                                label_name="label"
                                :showInput="true"
                                :block="true"
                                @onEdit="res => onEdit(res, 'point')"
                                :data="[{label:'적립율', value:0, num: prod_price.point_rate, unit:'%'},
                                          {label:'적립금', value:1, num: prod_price.point, unit:'원'}]"></lp-radio>
                    </admin-form-item>
                  </div>
                  <div class="column is-full">
                    <admin-form-item label="적립 예정 포인트">
                      <label class="label"
                            style="padding-left: 4px;">
                        {{ prod_price.salePoint | currency }}
                      </label>
                    </admin-form-item>
                  </div>
                </div>
              </div>
            </admin-box-item>
          </div>

          <a id="sb_comm_type" v-if="isAdmin && enablePanel('panel7')"></a>
          <div class="box tab-item" v-if="isAdmin && enablePanel('panel7')">
            <admin-box-item title="상품 거래 수수료 설정" :disabled="isMartAndPartner" :showToggleButton="true">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="수수료">
                    <lp-radio :val.sync="prod_price.is_comm"
                              value_name="value"
                              label_name="label"
                              :data="[{label:'개별설정',value:true}, {label:'기본설정', value:false}]"></lp-radio>
                  </admin-form-item>
                </div>
                <div v-if="prod_price.is_comm">
                  <div class="column is-full">
                    <admin-form-item label="수수료 방법">
                      <lp-radio :val.sync="prod_price.comm_type"
                                value_name="value"
                                label_name="label"
                                :showInput="true"
                                :block="true"
                                @onEdit="res => onEdit(res, 'comm')"
                                :data="[{label:'수수료율', value:0, num: prod_price.comm_rate, unit:'%'},
                                          {label:'수수료금액', value:1, num: prod_price.comm_price, unit:'원'}]"></lp-radio>
                    </admin-form-item>
                  </div>
                  <div class="column is-full">
                    <admin-form-item label="수수료 가격">
                      <label class="label"
                            style="padding-left: 4px;">
                        {{ prod_price.saleComm | currency }}
                      </label>
                    </admin-form-item>
                  </div>
                </div>
                <div class="column is-full" v-if="false">
                  <admin-form-item label="수수료 적용 기간">
                    <div class="flex" style="flex-wrap:wrap">
                      <div style="align-items: center;">
                        <admin-date-picker
                          type="datetime"
                          :data="prod_price.comm_start"
                          @setDate="selDateMin"></admin-date-picker>
                      </div>
                      <div class="lp-dating">&#126;</div>
                      <div style="align-items: center;">
                        <admin-date-picker
                          type="datetime"
                          :data="prod_price.comm_end"
                          @setDate="selDateMax"></admin-date-picker>
                      </div>
                    </div>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>

          <!-- 상품 SEO 정보 -->
          <a id="sb_seo" v-if="enablePanel('panel10')"></a>
          <div class="box tab-item" v-if="enablePanel('panel10')">
            <admin-box-item title="상품 SEO 정보" :disabled="isMartAndPartner" :showToggleButton="true">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="타이틀(Title)">
                    <input class="input"
                          :value="prod_seo.title"
                          @input="e => prod_seo.title = e.target.value"
                          placeholder="타이틀을 입력하세요."
                          type="text" maxlength="30">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="메타태그 작성자(Author)">
                    <input class="input"
                          :value="prod_seo.author"
                          @input="e => prod_seo.author = e.target.value"
                          placeholder="메타태그 작성자를 입력하세요."
                          type="text" maxlength="30">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="메타태그 설명(Description)">
                    <input class="input"
                          :value="prod_seo.desc"
                          @input="e => prod_seo.desc = e.target.value"
                          placeholder="메타태그 설명을 입력하세요."
                          type="text" maxlength="30">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="메타태그 키워드(Keyword)">
                    <input class="input"
                          :value="prod_seo.keyword"
                          @input="e => prod_seo.keyword = e.target.value"
                          placeholder="메타태그 키워드를 입력하세요."
                          type="text" maxlength="30">
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>

          <!-- 상품 파일 -->
          <!--<div class="box" v-if="prod.order_conversion_type===8">
            <admin-box-item :title="fileTitle.title"
                            :subtitle="fileTitle.subTitle">
              <div class="prod-file"
                  v-for="(file, idx) in prod.files" :key="`file-${idx}`">
                <div style="font-size:13px;margin-bottom:4px">{{ file }}</div>
                <button
                  @click="onRemoveFileButtonClicked(idx)">파일 삭제</button>
              </div>
              <input type="file"
                    @input="onUploadFile($event)">
            </admin-box-item>
          </div>-->
        </div>


        <div class="column is-full">
          <!-- 시간 예약 -->
          <template v-if="prod.package==='reservation'">
            <!-- 서비스 유형 -->
            <a id="sb_reserve_policy"></a>
            <panel-reserve-policy :prod="prod" :reservePolicy="reservePolicy"></panel-reserve-policy>
            <!-- 가격정보 -->
            <a id="sb_reserve_price"></a>
            <panel-reserve-price :prod_price="prod_price" :reservePrice="reservePrice"></panel-reserve-price>
          </template>

          <!-- 다운로드팩 상품 옵션 -->
          <template  v-if="enablePanel('panel8') && prod.order_conversion_type===8">
            <a id="sb_product_option"></a>
            <div class="box tab-item">
              <admin-box-item title="상품 옵션 정보" :showToggleButton="true">
                <div class="columns is-multiline">
                  <div class="column is-full">
                    <admin-form-item label="옵션 사용여부">
                      <lp-radio :val.sync="prod.enable_option"
                                value_name="value"
                                label_name="label"
                                :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
                    </admin-form-item>
                  </div>
                  <div class="column is-full" v-if="prod.enable_option">
                    <admin-form-item label="옵션 설정">
                      <button class="button is-primary" @click="$modal.show('downloadOptionModal')">상품 옵션 구성</button>
                    </admin-form-item>
                  </div>
                </div>
                <download-option :selectors="selectors"
                                 :order_conversion_type="prod.order_conversion_type"
                                 v-if="prod.enable_option"></download-option>
              </admin-box-item>
            </div>
          </template>

          <!-- 상품 옵션 정보 -->
          <template v-if="enablePanel('panel8') && prod.order_conversion_type!==8 && prod.order_conversion_type !== 1">
            <a id="sb_product_option"></a>
            <div class="box tab-item">
              <admin-box-item title="상품 옵션 정보" :showToggleButton="true">
                <div class="columns is-multiline relative">
                  <div class="column is-full">
                    <admin-form-item label="옵션 사용여부">
                      <lp-radio :val.sync="prod.enable_option"
                                value_name="value"
                                label_name="label"
                                :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
                    </admin-form-item>
                  </div>
                  <div class="column is-full" v-if="prod.enable_option">
                    <admin-form-item label="옵션 설정">
                      <button class="button is-primary" @click="clickOpenOption">상품 옵션 구성</button>
                    </admin-form-item>
                  </div>

                  <div class="box-disabled" v-if="isMartAndPartner"></div>
                </div>
                <template v-if="prod.enable_option">
                  <template v-if="prod.order_conversion_type === 10">
                    <reserve-option-stocks :reservePolicy="reservePolicy" :stocks="selectorStocks"></reserve-option-stocks>
                  </template>
                  <template v-else>
                    <lp-prod-option-stocks :selectors="selectorStocks"
                                           :requiredOptionStockUsing="requiredOptionStockUsing"
                                           @checkRequiredOption="checkRequiredOption"
                                           :requiredOptionTitle="requiredOptionTitle"
                                           :order_conversion_type="prod.order_conversion_type"
                                           v-if="prod.enable_option"></lp-prod-option-stocks>
                  </template>
                </template>
              </admin-box-item>
            </div>
          </template>

          <!-- 상품 재고 설정 -->
          <div class="box" v-if="visibleStockPanel">
            <admin-box-item :title="panel.stock.title" :showToggleButton="true">
              <div class="columns is-multiline">
                <!-- 재고 사용여부 -->
                <div class="column is-full">
                  <admin-form-item v-if="selectors.length === 0"
                                   :label="panel.stock.enable_stock_label">
                    <lp-radio :val.sync="prod.stock_type"
                              value_name="value"
                              label_name="label"
                              @onSelect="res => prod.stock_type=res"
                              :data="[{label:'사용',value:0},{label:'무한대',value:1}]"></lp-radio>
                  </admin-form-item>
                  <div class="label"
                       v-if="selectors.length > 0">상품 옵션 재고의 합</div>
                </div>
                <!-- 재고 사용 -->
                <div v-if="prod.stock_type===0 && selectors.length === 0">
                  <!-- 입고 수량 -->
                  <div class="column is-full flex-align">
                    <admin-form-item :label="panel.stock.input_number_label">
                      <div style="display:flex;align-items: center">
                        <input class="input product-short-input"
                               v-model="addCount"
                               @keyup.enter="addStock"
                               type="number">
                        <button class="button is-primary"
                                style="margin-left:8px;width:48px"
                                @click="addStock">추가</button>
                      </div>
                    </admin-form-item>
                  </div>
                  <!-- 주문 수량 -->
                  <div class="column is-full" v-if="$route.query.id">
                    <admin-form-item :label="panel.stock.order_number_label"
                                     justifyContent="space-between"
                                     :isFlex="true">
                      {{ prod.ordered_count }}개
                    </admin-form-item>
                  </div>
                  <!-- 재고 수량 -->
                  <div class="column is-full" v-if="$route.query.id">
                    <admin-form-item :label="panel.stock.stock_number_label"
                                     justifyContent="space-between"
                                     desc="재고 수량이 0개 인 경우에는 자동 '품절'처리 됩니다."
                                     :isHeaderBlock="true"
                                     :isFlex="true">
                      {{prod.stock}}개</admin-form-item>
                  </div>
                  <!--&lt;!&ndash; 재고 품절 여부 &ndash;&gt;
                  <div class="column is-full">
                    <admin-form-item :label="panel.stock.soldout_label">
                      <lp-radio :val.sync="prod.soldout"
                                value_name="value"
                                label_name="label"
                                @onSelect="res => prod.soldout=res"
                                :data="[{label:'품절',value:true},{label:'정상',value:false}]"></lp-radio>
                    </admin-form-item>
                  </div>-->
                </div>

                <!-- 상품 옵션 재고의 합 -->
                <div class="column is-full" v-if="selectors.length > 0">
                  <div v-if="selectors.length > 0">
                    <div class="flex" style="justify-content: space-between;width:100%;line-height:1.7rem"
                         v-for="(selector,idx) in selectorStocks" :key="'selector-'+idx">
                      <div>{{ selector.name }}</div>
                      <div>{{ selector.stock }}개 남음 / 누적 {{ selector.ordered_count }} 개 주문</div>
                    </div>
                  </div>
                </div>
              </div>
            </admin-box-item>
          </div>

          <div class="box" v-if="prod.order_conversion_type === 3 || prod.order_conversion_type === 12">
            <admin-box-item title="배송비 설정">
              <lp-prod-delivery-price :burden_type.sync="prod_price.burden_type"
                                      :pack="pack"
                                      :partner_id="partner_id"
                                      :product="prod"
                                      :delivery_price_id.sync="prod_price.delivery_price_id"></lp-prod-delivery-price>
            </admin-box-item>
          </div>

          <!-- 주문 가능 수량 한도 (commmerce, booking 에서 숨김) -->
          <div class="box" v-if="enablePanel('panel9') && [8, 10, 11].indexOf(prod.order_conversion_type)===-1">
            <admin-box-item title="주문 가능 수량 한도" :showToggleButton="true">
              <!-- 판매기간 있을 시 남은 판매 가능 시간 들어갈 곳 -->
              <div v-if="prod.order_conversion_type!==8">
                <admin-form-item
                  style="margin-bottom:20px"
                  :label="prod.order_conversion_type === 11 ? '주문 가능 숙박일 설정 (최소 ~ 최대)' : '1회 최소 ~ 최대 주문 수량 한도'">
                  <input class="input product-short-input"
                         v-model.number="prod.minimum"
                         @input="e => setNumber(e, 'prod', 'minimum', 5)"
                         type="number" maxlength="3">
                  <div class="lp-dating">&#126;</div>
                  <input class="input product-short-input"
                         v-model.number="prod.maximum"
                         @input="e => setNumber(e, 'prod', 'maximum', 5)"
                         type="number" maxlength="3">
                  <div class="flex" v-if="prod.order_conversion_type===11">
                    <div class="lp-txt-period" style="margin-right:28px">{{ periodDateText(prod.minimum) }}</div>
                    <div class="lp-txt-period">{{ periodDateText(prod.maximum) }}</div>
                  </div>
                  <div v-if="errorQuantity" style="font-size: 0.8rem;color: #db2828;margin-top: 8px;">
                    <span v-if="prod.order_conversion_type===11">주문 가능 숙박일</span>
                    <span v-else>1회 최소~최대 주문 수량</span> 설정이 잘못되었습니다.</div>
                </admin-form-item>

                <admin-form-item label="옵션별 설정"
                                 v-if="prod.enable_option">
                  <div v-if="requiredOptionTitle" class="flex-align">
                    <div style="margin-right:8px;width:50%">{{ requiredOptionTitle }}</div>
                    <input class="input product-short-input"
                           :value="requiredOptionMin"
                           @input="e=>inputRequiredOptionQuantity(e, 'minimum')"
                           type="number" maxlength="3">
                    <div class="lp-dating">&#126;</div>
                    <input class="input product-short-input"
                           :value="requiredOptionMax"
                           @input="e=>inputRequiredOptionQuantity(e, 'maximum')"
                           type="number" maxlength="3">
                  </div>

                  <div v-for="(opt,idx) in selectors" :key="'prod-limit-'+idx" class="flex-align" style="margin-top:8px" v-if="opt.option_type===1">
                    <div style="margin-right:8px;width:50%">{{ opt.name }}</div>
                    <input class="input product-short-input"
                           :value="opt.minimum"
                           @input="e=>inputAddOptionQuantity(e, 'minimum', opt)"
                           type="number" maxlength="3">
                    <div class="lp-dating">&#126;</div>
                    <input class="input product-short-input"
                           :value="opt.maximum"
                           @input="e=>inputAddOptionQuantity(e, 'maximum', opt)"
                           type="number" maxlength="3">
                  </div>
                </admin-form-item>
              </div>
            </admin-box-item>
          </div>

          <!-- 상품 상세정보 -->
          <a id="sb_product_detail"></a>
          <div class="box">
            <admin-box-item title="상품 상세정보" :disabled="isMartAndPartner">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item>
                    <lp-editor :text.sync="prod.info"></lp-editor>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>

          <!-- 상품 공통 고시정보 -->
          <a id="sb_product_common_info"></a>
          <div class="box">
            <admin-box-item title="상품 공통 고시정보" :disabled="isMartAndPartner">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item>
                    <div class="prod-reg-content">
                      <div v-for="(common_item, common_idx) in custom_common_info_arr" :key="`common-${common_idx}`"
                        class="common-info">
                        <lp-check-bool :checkedVal.sync="prod[common_item.key]"
                                       v-if="common_item.label"
                                       style="margin-bottom:12px"
                                       :labelStyle="{fontSize: '14px', color: '#363636', fontWeight: 700}"
                                       :label="common_item.label"></lp-check-bool>
                        <lp-editor :text.sync="prod.common_info[common_item.value]"
                                   style="margin-bottom:12px"
                                   v-if="prod[common_item.key]"></lp-editor>
                        <div v-else class="size-13" style="color:#787878">*미사용 시 파트너 상품 정보 제공 고시로 대체</div>
                      </div>
                    </div>
                    <!-- 댓글 등록 -->
                    <div v-if="false">
                      <div class="lp-bg-sub-header">
                        <span class="lp-bg-sub-title">상품 댓글 정보</span>
                      </div>
                      <div class="lp-devision" style="margin: 15px 1% 8px;"></div>
                      <div>
                        <!-- 댓글 목록 -->
                        <div>
                          <div class="comment-sub-title">
                            <span>댓글 목록 (1)</span>
                            <i class="material-icons" style="cursor: pointer;">keyboard_arrow_down</i>
                            <!--<i v-if="showCommentsList===true" @click="showCommentsList=false" class="material-icons" style="cursor: pointer;">keyboard_arrow_up</i>-->
                          </div>
                          <div>

                            <div style="margin-top: 12px;">
                              <div style="display:flex;">
                                <div style="font-size: .9rem; color: #555; flex: 1; display:flex;">
                                  <div class="avatar" style="width: 48px; height: 48px; border-radius: 50%; overflow: hidden;">
                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ1TlH_9WNmE_n6uzGrbfFCv2GDS7gOaWGkvEzogCsb0tSU7gI18A" style="width: 100%; height: 100%; object-fit: cover;">
                                  </div>
                                  <div class="msg-box" style="background-color: #f2f7f8; padding: 8px 16px; margin: 0px 16px; flex: 1; border-radius: 8px;">
                                    <div class="profile"><span style="margin-right: 12px;">나야나(wonowon)</span><span>18-02-12 12:30:45</span></div>
                                    <div class="message" style="word-break: break-all;">
                                      aslkdjflaskdjflaksjdflkasdjflaksjdflkas;jdfl;aksjdflkasjdfl;kasjdflkasjdflkajsdlf;kjasl;dkfjalskdjfasl;kdjfl;aksjdflkajsdfl;kasdf
                                    </div>
                                  </div>
                                </div>
                                <div style="display: flex; align-items: center; justify-content: center;">
                                  <div class="btn-update" style="padding: 6px 10px;">수정</div>
                                  <div class="btn-delete" style="padding: 6px 10px;">삭제</div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                        <div class="lp-devision" style="margin: 15px 1% 8px;"></div>

                        <!-- 댓글 작성 -->
                        <div>
                          <div class="comment-sub-title" style="margin-bottom: 20px;">댓글 작성</div>
                          <div style="display: flex; flex-direction: column;">

                            <div style="display: flex;">
                              <div style="width: 64px; color: #064160; font-weight: bold; font-size: 0.83rem; display:flex; align-items: center;"><span>작성자</span></div>
                              <lp-sort-drop-down width="200" style="display:inline-block; margin-right:4px;"></lp-sort-drop-down>
                            </div>

                            <div style="display: flex; margin-top: 12px;">
                              <div style="width: 64px; color: #064160; font-weight: bold; font-size: 0.83rem; display:flex; align-items: center;"><span>작성내용</span></div>
                              <textarea style="flex: 1; resize: none"></textarea>
                              <div style="background: #008fd9; color: #fff; border-radius: 3px; cursor: pointer; display:flex; justify-content: center; align-items: center; margin-left: 8px; padding: 32px 16px;">
                                <span>등록</span>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>

          <!-- 연관 상품 -->
          <template v-if="prod.name && enablePanel('panel11')">
            <a id="sb_related_product"></a>
            <div class="box tab-item">
              <admin-box-item title="관련 상품" :disabled="isMartAndPartner">
                <related-products :products.sync="prod.related_products"></related-products>
              </admin-box-item>
            </div>
          </template>
        </div>
      </div>
    </template>

    <!-- tab 2인 경우에만 표시되는 컴포넌트 -->
    <template v-if="prodTab === 1">
      <div class="detector"></div>
      <div class="columns is-multiline">
        <div class="column is-full">
          <!-- 숙박예약인 경우 -->
          <template v-if="prod.package === 'booking'">
            <!-- 가격 정보 -->
            <a id="sb_price_info"></a>
            <panel-booking-price ref="productPrice"
              :prod="prod"
              :prod_price="prod_price"
              @updatePrice="updatePrice"
              @save="saveData"
              @onUpdate="updateSchedule"
              @calcPrice="calcPrice"></panel-booking-price>

            <!-- 상품 일정 -->
            <a id="sb_days"></a>
            <panel-product-booking ref="panelBooking" :prod="prod"
                                  @updatePrice="updatePrice"
                                  @add="addBookingPrice"
                                  @save="saveData"></panel-product-booking>
          </template>
          <template v-else-if="prod.package === 'reservation'">
            <!-- 상품 일정 -->
            <a id="sb_resv_days"></a>
            <panel-product-reservation :prod="prod"
                                       :selectorStocks="selectorStocks"
                                       :reservePolicy="reservePolicy"
                                       :reservePrice="reservePrice"></panel-product-reservation>
          </template>
        </div>
      </div>
    </template>

    <!-- 저장하기 -->
    <div v-if="prodTab === 0" class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>

    <!-- 다운로드상품 옵션 팝업 -->
    <modal name="downloadOptionModal" :adaptive="true" :width="800" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="상품 옵션 구성" :useTab="false"
                        subtitle="상품 옵션을 직접 구성하거나 옵션 템플릿에서 가져와서 구성할 수 있습니다.">
          <download-option-modal :selectors.sync="selectors"
                                 :is_modify="is_modify"
                                 :order_conversion_type="prod.order_conversion_type"></download-option-modal>
        </admin-box-item>
      </div>
    </modal>

    <!-- 배송상품 옵션 팝업 -->
    <!--<modal name="optionModal" :adaptive="true" :width="800" height="auto" class="modal-style" @closed="closeOption">
      <div class="lp-modal-wrapper">
        <admin-box-item title="상품 옵션 구성" :useTab="false"
                        subtitle="상품 옵션을 직접 구성하거나 옵션 템플릿에서 가져와서 구성할 수 있습니다.">
          <lp-prod-option :selectors="selectors"
                          :is_modify="is_modify"
                          @closeOption="closeOption"
                          :category1="prod.category1_id"
                          :category2="prod.category2_id"
                          :category3="prod.category3_id"
                          :order_conversion_type="prod.order_conversion_type"></lp-prod-option>
        </admin-box-item>
      </div>
    </modal>-->

    <modal-product-option ref="optionModal" :prod="prod" :selectors="selectors"
                          @selector="onSelector"
                          @selectorStocks="onSelectorStocks"></modal-product-option>

    <!-- 결제방식 확인 모달 -->
    <modal name="checkPayMethodModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div style="padding:20px 0">
          결제 정보 입력이 필요한 팩입니다.<br>
          서비스 설정 관리 > 플랫폼 주문/결제 설정에서 결제 정보를 입력해주세요.
        </div>
        <div class="btn-group-justify-end">
          <button class="button" @click="$modal.hide('checkPayMethodModal')">취소</button>
          <button class="button is-primary" @click="routerPush(getPath('service/setting'))">설정하러가기</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import moment from 'moment'
  import InputImg from '../../module/common/InputImg'

  import LpAdmBtn from '../../module/common/LpAdmBtn'
  import LpSortDropDown from "../../module/common/LpSortDropDown"
  import LpCheckBool from "../../module/common/LpCheckBool"
  import LpCheckGroup from '../../module/common/LpCheckGroup'
  import LpRadio from "../../module/common/LpRadio"
  import LpInput from "../../module/common/LpInput"
  import LpInputText from "../../module/common/LpInputText"
  import LpInputTag from "../../module/common/LpInputTag"
  import LpAddress from '../../module/common/LpAddress'
  import LpDropdown from "../../module/common/LpDropdown"
  import LpProdOption from "../../module/common/LpProdOption"
  import LpProdOptionStocks from "../../module/common/LpProdOptionStocks"
  import LpRegionDropDown from "../../module/common/LpRegionDropDown"
  import InputParam from "../../module/custom/InputParam";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import LpEditor from "../../module/common/LpEditor";
  import InputFile from "../../module/common/InputFile";
  import CreateMixin from "@/mixins/CreateMixin"
  import LpProdDeliveryPrice from "../../module/common/lpProdDeliveryPrice";
  import PanelProductTime from "./component/PanelProductTime";
  import ProductPanelMixin from "../../../mixins/ProductPanelMixin";
  import PanelProductPrice from "./component/PanelProductPrice";
  import DownloadOption from "./component/DownloadOption";
  import DownloadOptionModal from "./component/DownloadOptionModal";
  import RelatedProducts from "./component/RelatedProducts";
  import Tab1 from "../../module/common/Tab1";
  import PanelDayPrice from "./component/PanelDayPrice";
  import PanelSuperVisor from "./component/PanelSuperVisor";
  import LpInputVideo from "../../module/common/LpInputVideo";
  import DragImgMultiple from "../../module/common/DragImgMultiple";
  import DragImgSingle from "../../module/common/DragImgSingle";
  import ProductPreview from "./component/ProductPreview";
  import PanelBookingPrice from "./component/PanelBookingPrice";
  import PanelBookingPolicy from "./component/PanelBookingPolicy";
  import PanelProductLocation from "./component/PanelProductLocation";
  import PanelProductBooking from "./component/PanelProductBooking";
  import PanelProductOrderPerformance from "./component/PanelProductOrderPerformance";
  import BtnProductOrderPerformance from "./component/BtnProductOrderPerformance";
  import PanelReserveDeadline from "./component/PanelReserveDeadline";
  import PanelReservePolicy from "./component/PanelReservePolicy";
  import PanelReservePrice from "./component/PanelReservePrice";
  import ModalProductOption from "./component/ModalProductOption";
  import ReserveOptionStocks from "./component/ReserveOptionStocks";
  import PanelProductReservation from "./component/PanelProductReservation";

  export default {
    name: 'BasicProductReg',
    props: {
      pack: {
        type: String,
        required: false
      }
    },
    layout: 'Main',
    components: {
      PanelProductReservation,
      ReserveOptionStocks,
      ModalProductOption,
      PanelReservePrice,
      PanelReservePolicy,
      PanelReserveDeadline,
      BtnProductOrderPerformance,
      PanelProductOrderPerformance,
      PanelProductBooking,
      PanelProductLocation,
      PanelBookingPolicy,
      PanelBookingPrice,
      ProductPreview,
      DragImgSingle,
      DragImgMultiple,
      LpInputVideo,
      PanelSuperVisor,
      PanelDayPrice,
      Tab1,
      RelatedProducts,
      DownloadOptionModal,
      DownloadOption,
      PanelProductPrice,
      PanelProductTime,
      LpProdDeliveryPrice,
      InputFile,
      draggable,
      LpEditor,
      LpAdmDropInput,
      InputParam,
      LpDropdown,
      LpInputTag,
      LpInputText,
      LpInput,
      LpRadio,
      LpCheckBool,
      LpCheckGroup,
      LpSortDropDown,
      InputImg,
      LpAdmBtn,
      LpAddress,
      LpProdOption,
      LpProdOptionStocks,
      LpRegionDropDown,
    },
    mixins: [
      CreateMixin,
      ProductPanelMixin
    ],
    watch:{
      'reservePolicy.limit_type'(n) {
        if(n === 1) {
          this.prod.enable_option = true;
        }
      },
      modalStatus(n) {
        // 최초 등록후 모달 취소 했을 경우
        if(n === 'cancel') {
          if(this.prod.id) {
            this.$router.replace(`${this.$route.path}?id=${this.prod.id}`);
          }
        }
      },
      '$route'() {
        this.is_modify= !!(this.$route.query.id);
        if(!this.is_modify) {
          this.$store.commit('setProdTab', 0);
          document.body.scrollTo(0,0);
        }
      },
      'prod.package'(n) {
        this.$store.commit('setProdPackage', n);
      },
      'selectedPack'() {
        this.initCategories();
        this.initCustomCommonInfo();
      },
      'prod.minimum'(n) {
        if(this.prod.minimum > this.prod.maximum) {
          this.prod.minimum = this.prod.maximum;
        }
        if(this.prod.minimum<1) {
          this.prod.minimum = 1
        }
      },
      'prod.maximum'(n) {
        if(this.prod.minimum > this.prod.maximum) {
          this.prod.maximum = this.prod.minimum;
        }
      },
      partner_id(n) {
        if(n>0) {
          this.$axios.get(this.getUrl(`partner/${n}`)).then(res=>{
            this.partner = res.data.partner;
          });
        }
      },
      'prod.phone'(n) {
        this.prod.phone = autoHyphenPhone(this.prod.phone)
      },
      'prod_price.discount_type'(n){
        if (n === 0)
          this.prod_price.saleDiscount = parseInt(this.prod_price.price) - (this.prod_price.price * parseFloat(this.prod_price.discount_rate) / 100);
        else
          this.prod_price.saleDiscount = parseInt(this.prod_price.price) - parseInt(this.prod_price.discount_price);
      },
      'prod_price.comm_type'(n){
        if (n === 0)
          this.prod_price.saleComm = parseInt(this.prod_price.price) * parseFloat(this.prod_price.comm_rate) / 100;
        else
          this.prod_price.saleComm = parseInt(this.prod_price.comm_price);
      },
      'prod_price.point_type'(n){
        if (n === 0)
          this.prod_price.salePoint = parseInt(this.prod_price.price) * parseFloat(this.prod_price.point_rate) / 100;
        else
          this.prod_price.salePoint = parseInt(this.prod_price.point);
      },
      isEqualPartnerPhone(n){
        if(n && this.partner_id>0){
          this.equalPartnerPhone();
          this.prod.enable_phone = true;
          return true;
        }
        else {
          this.prod.enable_phone = false;
          return false;
        }
      },
      isEqualPartner(n){
        if(n && this.partner_id>0){
          this.equalPartner();
        }
      },
      'prod.order_conversion_type'(n){
        this.changeConversionType(n);
      },
      'prod.category1_id'(n){
        this.cat2 = this.get_cat(this.catArr2, n);
      },
      'prod.category2_id'(n){
        this.cat3 = this.get_cat(this.catArr3, n)
      },
      '$store.getters.prodTab'(n) {
        document.body.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    created() {
      this.$store.commit('setProdTab', 0);
      if(this.$route.query.id)
        this.is_modify=true;

      if(this.$store.getters.mode==='partner'){
        this.partner_id = this.$store.getters.partner.partner_id;
      }
      // 1. 패키지들 2. 카테고리들 3. 상품정보 순서대로 가져온다.
      this.initPage();
      this.getData();
      this.getOrderSetting();
    },
    data() {
      return {
        isFixed: false,
        enableButton: true,
        social_key: undefined,
        orderSetting: undefined,
        product_setting: undefined,
        percentCompleted: 0,
        custom_common_info_arr: [
          {label: '상품 정보 제공 고시',key:'enable_use_info', value: 'use_info'},
          {label: '배송안내',key:'enable_delivery_info',value: 'delivery_info'},
          {label: '교환 및 반품안내',key:'enable_refund_info', value: 'refund_info'}
        ],
        autoStatusArr: [
          {label: '결제즉시 예약확정', value: true},
          {label: '관리자 승인 후 예약확정', value: false}
        ],
        basic_package: '',
        packages: [],
        packageSettings: [],
        // 선택된 팩
        selectedPack: 0,
        loading: false,
        isEqualPartner: false,
        isEqualPartnerPhone: false,
        is_modify:false,
        selectedTab: 0,
        partners: [],
        // mode가 partner일 경우는 vuex에서 partner id 가져 옴
        partner_id:0,

        // 파트너 정보
        partner: {id:0},

        // 주문, 전환 정보
        performance:{
          visit: 0,
          inquiry: 0,
          like: 0,
          review: 0
        },
        conversion: {
          before: 0,
          after: 0
        },
        // 입고 수량
        addCount: 0,
        stockCount: 0,
        // 상품 기본 정보,
        prod:{
          enable_use_info: false,
          enable_delivery_info: false,
          enable_refund_info: false,
          code: '',
          video: '',
          package: '',
          partner_list: [],
          super_visor_id: '',
          priority: 99,
          sns_inquiry_type: 0,
          naver: '',
          instagram: '',
          kakao: '',
          homepage: '',
          enable_naver: false,
          enable_instagram: false,
          enable_kakao: false,
          enable_homepage: false,
          is_super_visor: false,
          related_products: [],
          enable_age_verify: false,
          approval_type: 1,
          // 입고 수
          input: 0,
          stock: 0,
          soldout: false,
          maximum: 99,
          minimum: 1,
          stock_type: 1,
          enable_prod: true,
          enable_option: false,
          enable_link: false,
          enable_counsel: false,
          counsel_form_id:'',
          enable_meet: false,
          meet_form_id:'',
          first_img: '',
          imgs:[],
          files: [],
          simple_desc:'',
          info:'',
          name:"",
          category1_id:"",
          category2_id:"",
          category3_id:"",
          inquiry_conversion_type: 0,
          order_conversion_type: 0,
          payment_type: 0,
          auto_resv_status: true,
          // 상품 공통 정보
          custom_common_info:false,
          common_info:{
            use_info:'',
            delivery_info:'',
            refund_info:'',
          },
          address:{
            sido: '',
            sigungu: '',
            dong: '',
            detail: '',
            post_code: '',
            old: '',
            new: ''
          },
          phone: '',
          enable_phone: false,
          tags:[]
        },
        // 상품 시간 관리
        prod_schedule: {
          start_datetime: undefined,
          end_datetime: undefined,
          repeat_type: 0,
          stock: 0
        },
        // 맞춤 DB
        param_list:[],
        // 요일별 가격 설정
        product_day_price: [],
        // 상품 가격 정보
        prod_price:{
          unit: 'kg',            // 단위
          start_date:'',
          end_date:'',
          is_discount: false,
          is_comm: false,
          is_point: false,
          price: 0,
          price_type:0,
          price_text:'',
          discount_type: 0,
          discount_rate: 0,
          discount_price: 0,
          discount_period_type: false,
          discount_start:'',
          discount_end:'',
          discount_time: [],
          delivery_price_id: undefined,
          comm_rate:0,
          comm_price:0,
          comm_type:0,
          point_type:0,
          point:0,
          point_rate:0,
          won_type: 0,
          comm_start: '',
          comm_end: '',
          burden_type: 0
        },
        // 상품 파일
        prodFile: {
          url: null,
          file: null,
        },
        // 상품 검색 정보
        prod_seo:{
          title:"",
          author:"",
          desc:"",
          keyword:""
        },
        prod_param: [],
        // 옵션
        selectors:[
          /*{
            minimum:1,
            maximum:100,
            required:true,
            selector_id:1
          }*/
        ],
        // 옵션 - 재고수량
        selectorStocks: [],
        // 카테고리
        categories: [],   // 전체 카테고리
        catArr1: [],
        cat2: [],         //1차 카테고리 관련된 카테고리만
        cat3: [],         //2차 카테고리 관련된 카테고리만
        catArr2: [],
        catArr3: [],
        // 주문 전환
        order_conversion_arr: [],
        // 전체 주문 전환 목록
        orderConversionArr: [
          { label:'없음',value:0 },
          { label:'전화연결',value:1 },
          { label:'아웃링크',value:2 },
          { label:'상품배송주문',value:3 },
          { label:'모임신청',value:4 },
          { label:'상담신청',value:5 },
          { label:'견적요청',value:6 },
          { label:'사용권',value:7 },
          { label:'컨텐츠 다운로드주문',value:8 },
        ],
        // 상담 신청 폼 목록 ( label, value )
        counselFormArr: [],
        // 참여 신청 폼 목록
        meetFormArr: [],
        // 판넬 구성 내용
        panel: {
          // 할인
          discount: {
            title: '할인 가격 설정',
            enable_discount_label: '할인 가격 사용여부',
            discount_type_label: '할인 방법',
            discount_label: '할인 후 가격'
          },
          // stock
          stock: {
            title: '상품 재고 설정',
            enable_stock_label: '재고 사용여부',
            input_number_label: '입고',
            order_number_label: '주문 수량',
            stock_number_label: '재고 수량',
            soldout_label: '품절 여부',
            option: {
              enable_stock_label: '재고 사용여부',
              option_label: '옵션명:',
              stock_number_label: '재고 수량'
            }
          }
        },
        // 시간예약 설정
        reservePolicy: {
          deadline_time: 24,
          limit_type: 0,
          limit_count: false,
          minimum: 1,
          maximum: 1
        },
        originReservePolicy: undefined,
        reservePrice: []
      }
    },
    computed: {
      prodTab() {
        return this.$store.getters.prodTab;
      },
      isMobile() {
        return this.$store.getters.device === 'mobile'
      },
      computedMenuName() {
        if (this.prodTab === 0) {
          return '상품 정보';
        } else if (this.prodTab === 1) {
          return '예약 일정/가격';
        }
      },
      inquiryConversionArr() {
        let list = [{ label:'없음',value:0 },
          { label:'전화문의',value:1 },
          { label:'이메일문의',value:2 }]
        if(this.prod.package==='call') {
          let index = list.findIndex(item=> item.label==='전화문의')
          removeIndex(list, index);
        }
        return list;
      },
      conversionTitle() {
        let text = `문의 전환, 결제방식 선택`
        if([0,1,2,5,6].indexOf(this.prod.order_conversion_type) === -1) {
          text = '문의 전환, 결제방식 선택'
        } else {
          text = '문의 전환 선택'
        }
        return text
      },
      enablePreview() {
        return this.prod && this.prod.package && ['call', 'reservation', 'booking', 'delivery'].indexOf(this.prod.package) > -1;
      },
      paymentTypeArr() {
        let list = [{label:'결제 없음',value:0},{label:'결제있음',value:1},{label:'현장결제',value:2}];

        let pack = this.packageSettings.filter(item=>{ return item.package === this.selectedPack.name })[0];
        if(pack) {
          list = list.slice(0, pack.able_payment_type+1);
        }

        if(this.prod.package==='delivery') {
          removeIndex(list, 0);
        };
        return list;
      },
      isMartAndPartner () {
        return this.isMart && this.$store.getters.mode==='partner' && this.prod.is_super_visor;
      },
      isMart () {
        let is_mart = find(this.packages, 'name', 'mart');
        if(is_mart) return true;
        else return false;
      },
      verifyTitle () {
        if(this.isInternalPlugin('age_verify')) {
          return '상품 성인인증 여부';
        }
        else if(this.isInternalPlugin('identity_verify')) {
          return '상품 본인인증 여부';
        }
        else {
          return ''
        }
      },
      errorQuantity () {
        if(this.prod.minimum > this.prod.maximum) return true;
        else return false;
      },
      visibleStockPanel () {
        if(!this.selectedPack) return false;
        if(this.enablePanel('panel6') && [8, 10, 11].indexOf(this.selectedPack.id) === -1) {
          return !(this.selectedPack.id === 4 && this.prod.repeat_prop === 1);
        }
        else return false
      },
      requiredOptionMin () {
        let opt = this.selectors.filter(i => i.option_type === 0);
        return opt.length > 0 ? opt[0].minimum : 0;
      },
      requiredOptionMax () {
        let opt = this.selectors.filter(i => i.option_type === 0);
        return opt.length > 0 ? opt[0].maximum : 0;
      },
      // 필수 옵션 재고 사용 여부
      requiredOptionStockUsing () {
        let opt = this.selectors.filter(i => i.option_type === 0);
        return opt.length > 0 ? opt[0].stock_using : false;
      },
      // 예약, 숙박 팩일 경우 필수 옵션 타이틀
      requiredOptionTitle () {
        return this.selectors.filter(i => i.option_type === 0).reduce((a,c) => a === '' ? c.name : a + ' X ' + c.name, '');
      },
      // 상품 주문/전환 종류
      productType() {
        let packname = this.selectedPack ? this.selectedPack.kor_name : undefined;
        let conversion = find(this.orderConversionArr, 'value', this.prod.order_conversion_type);
        let pack = '';
        if(packname !== undefined) {
          pack = `${packname} / `
        } else {
          return '';
        }
        let conv_label = '';
        if(conversion) {
          conv_label = conversion.label;
        }
        return `${pack}${conv_label}`;
      },
      // 파트너 이름
      partnerName(){
        return this.partner_id > 0 && this.partners.length > 0 ? find(this.partners, 'value', this.partner_id).name : '';
      },
      // 상품 현황
      // productSituation() {
      //   // 상품 판매 사용
      //   if(this.prod.enable_prod) {
      //     // 상품 판매 날짜가 있을 경우
      //     if(this.prod_price.start_date && this.prod_price.end_date){
      //       let isBool1 = moment(this.prod_price.start_date).isBefore(moment());
      //       let isBool2 = moment(this.prod_price.end_date).isAfter(moment());
      //       if( isBool1 && isBool2 ){
      //         return '판매중';
      //       }
      //       else return '마감';
      //     }
      //     // 재고 없을 경우
      //     else if(this.prod.stock_type===0 && this.prod.stock===0) return '품절';
      //     // 날짜 선택 안했을 경우
      //     else if(!this.prod_price.start_date && !this.prod_price.end_date){
      //       return '판매중';
      //     }
      //     else return '마감';
      //   }
      //   // 상품 판매 사용안함
      //   else {
      //     return '마감';
      //   }
      // },
      // 상품 파일 제목, 부제목
      fileTitle() {
        let file = {
          title: '상품 파일',
          subtTitle: ''
        };

        if(this.isInternalPlugin('audioplayer')) {
          file.title = '미리듣기 음원 등록';
          file.subTitle = '미리듣기 음원 파일을 업로드해주새요.';
        }

        return file;
      }
    },
    methods: {
      onSelector(res) {
        this.selectors = res;
      },
      onSelectorStocks(res) {
        // reservation일때, 초기 stock 10으로 지정
        if (this.prod.package === 'reservation') {
          res.forEach(stock => {
            stock.stock = 10;
          })
        }
        this.selectorStocks = res;

      },
      clickOpenOption() {
        this.$refs.optionModal.open();
      },
      addBookingPrice() {
        this.$refs.productPrice.clickAdd();
      },
      updateSchedule() {
        this.$refs.panelBooking.getDates();
      },
      // 결제 수단 확인, 결제 수단 활성화 여부 판단
      checkPayMethod() {
        let enable = true;

        // 확인할 팩 대상
        let packs = ['delivery','mart','booking','reservation'];

        // 대상이 아닌 경우 true
        if(packs.indexOf(this.prod.package)===-1) {
          return true;
        }

        // 결제 수단 체크 하나도 안되어 있을 경우 false
        else {
          if(this.orderSetting===undefined) {
            return false;
          }
          enable = this.orderSetting.paylist.some(item=>{
            return item.pay_type.some(item1=>{
              return !!item1.enable
            })
          });
          // false이면 하위 로직 실행 안하고 return
          if(!enable) {
            return enable;
          }
        }

        // 결제 수단 사용할 경우 결제 정보 입력이 안되어 있을 경우 false
        for(let i=0; i<this.orderSetting.paylist.length; i++) {
          let item2 = this.orderSetting.paylist[i];
          for(let j=0; j<item2.pay_type.length; j++) {
            let item3 = item2.pay_type[j]
            if(item3.name==='nobank' && item3.enable) {
              if(!(this.orderSetting.bank.account_num && this.orderSetting.bank.bank && this.orderSetting.bank.name)) {
                enable = false;
                break;
              }
            }
            if((item3.name==='phone' && item3.enable) || (item3.name==='credit' && item3.enable) ||
              (item3.name==='vbank' && item3.enable)) {
              if(!(this.social_key.inicis.mid && this.social_key.inicis.sign_key)) {
                enable = false;
                break;
              }
            }
            if(item3.name==='kakaopay' && item3.enable) {
              if(!(this.social_key.kakao.admin_key && this.social_key.kakao.cid)) {
                enable = false;
                break;
              }
            }
          }
        }
        return enable;
      },
      getOrderSetting() {
        // OrderSetting 호출 (기본 결제방식, 무통장입금 은행)
        this.$axios.get(this.getUrl('v1/order/setting')).then(res => {
          this.orderSetting = res.data;
        });
        this.$axios.get('admin/service/social_key').then(res => {
          if (res.status === 200) {
            if(res.data && res.data.social_key) this.social_key = res.data.social_key
          }
        });
      },
      getProductSetting() {
        this.$axios.get(this.getUrl('product/setting')).then(res=> {
          this.product_setting = res.data;
          this.prod.enable_use_info = this.product_setting.enable_use_info;
          this.prod.enable_delivery_info = this.product_setting.enable_delivery_info;
          this.prod.enable_refund_info = this.product_setting.enable_refund_info;
        })
      },
      selectPartnerId (res) {
        let partner_id = res.value;
        if(partner_id==='') {
          partner_id = 0;
        } else {
          this.isEqualPartnerPhone = true;
        }
        this.partner_id = partner_id;
        if(this.isEqualPartner) this.isEqualPartner = false;
      },
      getProdInfoForm() {
        this.$axios.get('public/text/form', {
          params: {
            type: 'prod_info'
          }
        }).then(res => {
          if(res.data) {
            this.prod.info = res.data.text;
          }
        })
      },
      // 추가 옵션 최소, 최대 주문 수량
      inputAddOptionQuantity (e, type, selector) {
        let value = parseInt(e.target.value);
        selector[type] = value;
        for(let i=0; i<selector.options.length; i++) {
          selector.options[i][type] = value;
        }
      },
      // 필수 옵션 최소, 최대 주문 수량
      inputRequiredOptionQuantity (e, type) {
        let value = parseInt(e.target.value)
        for(let i=0; i<this.selectors.length; i++) {
          if(this.selectors[i].option_type===0) {
            this.selectors[i][type] = value;

            if(type==='minimum') {
              if(this.selectors[i]['minimum'] > this.selectors[i]['maximum']) {
                this.selectors[i]['minimum'] = this.selectors[i]['maximum'];
              }
              if(this.selectors[i]['minimum'] < 1) {
                this.selectors[i]['minimum'] = 1;
              }
            }
            if(type==='maximum') {
              if(this.selectors[i]['minimum'] > this.selectors[i]['maximum']) {
                this.selectors[i]['maximum'] = this.selectors[i]['minimum'];
              }
            }

            let selector = this.selectors[i];
            for(let j=0; j<selector.options.length; j++) {
              selector.options[j][type] = value;
              // console.log(selector, selector.options[j], type, value)
            }
          }
        }
      },
      checkRequiredOption (value) {
        for(let i=0; i<this.selectors.length; i++) {
          if(this.selectors[i].option_type===0) {
            this.selectors[i].stock_using=value;
          }
        }
      },
      initPage() {
        if(this.isAdmin) {

        }
        else {

        }
      },
      selDateMin(date){
        this.prod_price.comm_start=date;
      },
      selDateMax(date){
        this.prod_price.comm_end=date;
      },
      // 상품 수정 페이지 일경우 호출( 할인 후 가격을 계산 )
      getCalculatePrice() {
        if(this.prod_price.comm_type===0){
          this.onEdit({text:this.prod_price.comm_rate, value:this.prod_price.comm_type}, 'comm');
        }
        else if(this.prod_price.comm_type===1){
          this.onEdit({text:this.prod_price.comm_price, value:this.prod_price.comm_type}, 'comm');
        }
        if(this.prod_price.discount_type===0){
          this.onEdit({text:this.prod_price.discount_rate, value:this.prod_price.discount_type}, 'discount');
        }
        else if(this.prod_price.discount_type===1){
          this.onEdit({text:this.prod_price.discount_price, value:this.prod_price.discount_type}, 'discount');
        }
        if(this.prod_price.point_type===0){
          this.onEdit({text:this.prod_price.point_rate, value:this.prod_price.point_type}, 'point');
        }
        else if(this.prod_price.point_type===1){
          this.onEdit({text:this.prod_price.point, value:this.prod_price.point_type}, 'point');
        }
      },
      // 컨버전 타입이 바뀜에 따라 판넬의 라벨 혹은 타이틀 데이터가 수정됨
      changeConversionType(n) {
        // 모임 신청
        if (n===4) {
          this.panel.stock = {
            title: '참여 신청 가능 인원',
            enable_stock_label: '참여 신청 가능 인원 사용여부',
            input_number_label: '참여 신청 가능 인원',
            order_number_label: '신청 인원',
            stock_number_label: '신청 가능 인원',
            soldout_label: '품절 여부',
            option: {
              enable_stock_label: '참여 신청 가능 인원 사용여부',
              option_label: '옵션명:',
              stock_number_label: '신청 가능 인원'
            }
          }
        }
        // 상담 신청
        if (n===5) {
          this.panel.stock = {
            title: '상담 신청 가능 인원',
            enable_stock_label: '상담 신청 가능 인원 사용여부',
            input_number_label: '상담 신청 가능 인원',
            order_number_label: '신청 인원',
            stock_number_label: '신청 가능 인원',
            soldout_label: '품절 여부',
            option: {
              enable_stock_label: '상담 신청 가능 인원 사용여부',
              option_label: '옵션명:',
              stock_number_label: '신청 가능 인원'
            }
          }
        }

      },
      // 선택된 팩 string으로 반환 ( ex) commerce )
      integerToStringSelectedPack() {
        return this.packages && this.selectedPack ? find(this.packages, 'id', this.selectedPack.id).name : '';
      },
      // 선택된 카테고리의 상품종류들 띄우기
      isCategoryMatchingPack(pack){
        for(let x=0; x<this.packages.length; x++){
          if(this.packages[x].name === 'launchpack'){
            return false;
          }
        }
        let get_pack = []
        // 카테고리별 상품종류(팩 종류) 배열에 담기
        for(let i=0; i<this.catArr1.length; i++){
          if(this.prod.category1_id === this.catArr1[i].value){
            get_pack = this.catArr1[i].packages;
            break;
          }
        }
        for (let j=0; j<get_pack.length; j++){
          // all 일경우 패키지들 다 반환시킴
          if(get_pack[j] === 'all') {
            return pack.name;
          }
          // 상품종류에 맞게 반환
          else if(get_pack[j] === pack.name) {
            return pack.name;
            break;
          }
        }
      },
      async clickCategory(value, type) {
        if (type === 'cat1') {
          this.prod.category1_id = value;
          this.prod.category2_id = '';
          this.prod.category3_id = '';
        }
        else if (type === 'cat2') {
          this.prod.category2_id = value;
          this.prod.category3_id = '';
        }
        else if (type === 'cat3') {
          this.prod.category3_id = value;
        }
      },
      selectedCategory(cat_id, type) {
        let arr = this[type === 'cat1' ? 'catArr1' : type].filter(item => { return item.value === cat_id });
        return arr.length > 0 ? arr[0].label : '';
      },
      equalPartnerPhone() {
        let partner_id = this.getPartnerId();
        this.$axios.get(this.getUrl('partner/' + partner_id)).then(res => {
          if (res.status === 200) {
            this.prod.phone = res.data.partner.phone;
          }
        })
      },
      equalPartner() {
        let partner_id = this.getPartnerId();
        this.$axios.get(this.getUrl('partner/' + partner_id)).then(res => {
          if (res.status === 200) {
            this.prod.name = res.data.partner.name;
            if(res.data.partner.address){
              if(this.prod.address) {
                let address = res.data.partner.address;
                address.id = this.prod.address.id;
                this.prod.address = address;
              } else {
                this.prod.address = res.data.partner.address;
              }
            }
            this.prod.imgs = res.data.partner.imgs;
            this.prod.first_img = res.data.partner.first_img;
            this.prod.simple_desc = res.data.partner.simple_desc;
            this.prod.info = res.data.partner.info;
          }
        })
      },
      getPartnerId() {
        let partner_id = '';
        if(this.$store.getters.mode==='admin') {
          partner_id = this.partner_id;
        }
        else if(this.$store.getters.mode==='partner'){
          partner_id = this.$store.getters.partner.partner_id;
        }
        return partner_id;
      },
      // 상품 노출 여부
      onSelectedProdState(val) {
        this.prod.enable_prod = val;
      },
      // radio edit반환값
      onEdit(res, type) {
        if(res.text==='' || res.text===0) res.text=0;
        if ( type === 'comm' ){
          if (res.value === 0) {
            this.prod_price.comm_rate = parseFloat(res.text);
          }
          else {
            this.prod_price.comm_price = parseInt(res.text);
          }
        }
        else if ( type === 'point' ){
          if (res.value === 0) {
            this.prod_price.point_rate = parseFloat(res.text);
          }
          else {
            this.prod_price.point = parseInt(res.text);
          }
        }
        this.calcPrice();
      },
      updatePrice(res) {
        ['sale_price', 'price', 'is_discount', 'discount_price', 'discount_rate', 'discount_type'].forEach(key=>{
          this.prod_price[key] = res[key];
        });
      },
      showProduct() {
        const a = document.createElement('a');
        a.href = `${this.$store.getters.brand.domain}/product_detail?id=${this.$route.query.id}`
        a.target = '_blank';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.parentNode.removeChild(a);
      },
      saveData(){
        // 관리자 경우는 승인 요청과 상관없이 상품 승인 자동
        // 파트너 일경우만 체크함
        if(!this.isAdmin && this.is_modify===false) {
          // 상품 승인요청 여부 사용했을 경우
          if(this.isInternalPlugin('product_approval')) {
            // 상품 승인 타입 (미승인)
            this.prod.approval_type = 0;
          }
          // 사용 안할 경우
          else {
            // 상품 승인 타입 (승인)
            this.prod.approval_type = 1;
          }
        }
        this.saveProduct();
      },
      // 상품 등록 api
      async saveProduct() {
        let err = '';
        if(!this.prod.name) err = '상품이름을 입력하세요.';
        // if(this.prod.enable_phone && !this.prod.phone) err = '전화연결 할 번호를 정확히 입력해주세요.';

        if(this.prod.package!=='delivery' && this.prod.package!=='mart' && this.$store.getters.mode==='admin'){
          if(!this.partner_id) err = '파트너를 선택하세요.';
        }
        if((this.prod.package==='delivery' && this.$store.getters.mode==='admin') ||
          (this.prod.package==='mart' && this.$store.getters.mode==='admin')) {
          if(!this.prod_price.delivery_price_id) err = '배송비 조건을 선택하세요.';
        }

        // if(this.prod.package==='mart' && this.isAdmin) {
        //   // console.log('is_super_visor',this.$refs.panelSuperVisor.is_super_visor)
        //   if(!this.prod.super_visor_id) err = '슈퍼바이저를 선택하세요.'
        // }

        /* 마스터 백오피스일 경우 예외처리 */
        if (this.packages[0].name ==='launchpack') {
          if(!this.prod.theme_id) err = '테마를 선택하세요.'
        }

        if(this.prod.minimum>this.prod.maximum) {
          if(this.prod.order_conversion_type===11) err = '주문 가능 숙박일 설정이 잘못되었습니다.';
          else err = '1회 최소~최대 주문 수량 한도 설정이 잘못되었습니다.';
        }
        if(this.prod.enable_option && this.selectors.length===0) {
          err = '상품옵션을 구성해 주세요.';
        }
        if(this.$refs.productPrice && this.$refs.productPrice.errorTime) {
          err = '시작 시간/종료 시간 범위 설정이 잘못되었습니다.';
        }
        if(this.$refs.productPrice && this.$refs.productPrice.errorDiscountTime) {
          err = '시작 시간/종료 시간 범위 설정이 잘못되었습니다.';
        }

        if(this.prod.package === 'reservation') {
          if(!this.reservePrice || this.reservePrice.length===0) {
            err = '설정된 가격정보가 없습니다.';
          } else {
            // 판매기간 설정
            let reservePrice = this.cloneItem(this.reservePrice)
            this.prod_price.start_date = reservePrice.map(i => i.start_date).sort()[0] + ' 00:00';
            if(reservePrice.some(i => i.end_date === '' || !i.end_date)) {
              this.prod_price.end_date = '9999-01-01 00:00';
            } else {
              this.prod_price.end_date = reservePrice.map(i => i.end_date).sort().slice(-1)[0] + ' 00:00';
            }
            let min_price = reservePrice.sort((a,b) => a.sale_price - b.sale_price)[0];
            ['price', 'sale_price', 'is_discount', 'discount_type', 'discount_rate', 'discount_price'].forEach(key => {
              this.prod_price[key] = min_price[key];
            });
          }
        }

        if(!this.prod.category1_id) err = '카테고리를 선택해주세요.';

        if(!this.selectedPack) err = '상품 종류를 선택해주세요.';

        if(err){
          this.toast(err);
          return;
        }

        // 결제정보 입력을 요구하는 모달 표시 : 필수사항 alert표시로 주석처리함. (2022-07-15)
        /*if(this.checkServiceVersion(2) && this.checkPayMethod()===false) {
          this.$modal.show('checkPayMethodModal');
          return;
        }*/

        // 버튼 (비)활성화 처리
        if(!this.enableButton) {
          return;
        }

        this.enableButton = false;

        // 기간예약 - 정책
        if(this.$refs.bookingPolicy) {
          this.prod.booking_policy = this.$refs.bookingPolicy.value;
          if (this.$refs.bookingPolicy.value.check_in === '' || this.$refs.bookingPolicy.value.check_out === '') {
            this.toast('체크인/체크아웃 시간을 입력해주세요.');
            this.enableButton = true;
            return;
          }
        }

        let config = '';
        if(this.prod.video) {
          this.showProgressToast('상품 저장중..', 0);
          let vm = this;
          config = {
            onUploadProgress: (progressEvent)=> {
              let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
              vm.percentCompleted = percentCompleted;
              this.showProgressToast('상품 저장중..', percentCompleted);
            }
          }
        }
        else this.$store.commit('setLoading', true);
        // 수정시
        if(this.is_modify){
          let url = `product/${this.$route.query.id}`;
          let prod = this.cloneItem(this.prod);
          let prod_price = this.cloneItem(this.prod_price);
          if(!prod_price.start_date) {
            prod_price.start_date = prod.package === 'booking' ? this.moment().format('YYYY-MM-DD 00:00') : '1111-01-01 00:00';
          }
          if(!prod_price.end_date){
            prod_price.end_date = '9999-01-01 00:00';
          }
          let params = {
            product: prod,
            price: prod_price,
            seo: this.prod_seo,
            params: this.prod_param,
            selectors: this.selectors,
            selectorStocks: this.selectorStocks,
            reservePolicy: this.reservePolicy,
            reservePrice: this.reservePrice
          }
          let enable_save = true;
          if(this.$store.getters.mode==='admin') {
            prod.partner_id = this.partner_id;
            // File
            if (this.prodFile.url !== null) {
              prod.files.push(this.prodFile.url);
            }
            // params['option'] = this.option;
          }
          else if(this.$store.getters.mode==='partner') {
            prod.partner_id = this.$store.getters.partner.partner_id;
          }
          else if(this.$store.getters.mode==='supervisor') {

          }
          if(this.selectedPack.name){
            prod.package = this.selectedPack.name;
          }

          if (prod.package === 'reservation' && this.reservePolicy.limit_type !== this.originReservePolicy.limit_type) {
            if (confirm('모집인원 제한 방식이 변경되면, 일정의 재고 수량이 변경될 수 있습니다. 그래도 저장하시겠습니까?')) {
              enable_save = true;
            } else {
              enable_save = false;
            }
          } else {
            enable_save = true;
          }

          if (enable_save) {
            this.$axios.patch(this.getUrl(url),params, config).then(res=>{
              if(res.status===200){
                this.enableButton = true;
                if(this.prod.video) this.closeProgressToast();
                else this.$store.commit('setLoading', false);
                this.toast('저장되었습니다.');

                // 상품 목록으로 이동
                if(['reservation', 'booking'].indexOf(this.prod.package) === -1) {
                  this.$router.push(this.$route.path.replace('/create',''));
                }

                // this.getData();
                // this.$refs.productTime.initRepeatPropArr();
              }
            }).catch(error=>{
              this.enableButton = true;
              if(this.prod.video) this.closeProgressToast();
              else this.$store.commit('setLoading', false);
              if (error.response) {
                if(error.response.data.message) this.toast(error.response.data.message);
                else this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
              }
            });
          }
        }
        // 등록시
        else{
          let url='product';
          let prod = this.cloneItem(this.prod);
          prod.partner_id = this.$store.getters.partner.partner_id;
          if(this.selectedPack!==''){
            prod.package = this.integerToStringSelectedPack();
            if(prod.package==='booking') prod.repeat_prop = 1
          }
          let prod_price = this.cloneItem(this.prod_price);
          if(!prod_price.start_date) {
            prod_price.start_date = prod.package === 'booking' ? this.moment().format('YYYY-MM-DD 00:00') : '1111-01-01 00:00';
          }
          if(!prod_price.end_date){
            prod_price.end_date = '9999-01-01 00:00';
          }
          let params = {
            product: prod,
            price: prod_price,
            seo: this.prod_seo,
            params: this.prod_param,
            selectors: this.selectors,
            selectorStocks: this.selectorStocks,
            reservePolicy: this.reservePolicy,
            reservePrice: this.reservePrice
          }
          if(this.$store.getters.mode==='admin') {
            prod.partner_id = this.partner_id;
            // File
            if (this.prodFile.url !== null) {
              prod.files.push(this.prodFile.url);
            }
          }
          // 상품 시간
          // let schedules = undefined;
          // if(this.$refs.productTime) {
          //   let prodTime = this.$refs.productTime;
          //   // 1회 일정
          //   if(prodTime.repeat_prop === 0 && !prodTime.is_closed && prodTime.start_date!=='') {
          //     schedules = [{
          //       start_date: prodTime.start_date,
          //       start_time: prodTime.start_time,
          //       end_date: prodTime.end_date,
          //       end_time: prodTime.end_time,
          //     }];
          //   }
          //   // 반복 일정
          //   else if(prodTime.repeat_prop === 1 && prodTime.$refs.calendar && prodTime.$refs.calendar.newDates.length>0){
          //     schedules = prodTime.$refs.calendar.newDates;
          //   }
          // }
          this.$axios.post(this.getUrl(url), params, config).then(res=>{
            if(res.status===200){
              this.enableButton = true;
              this.prod.id = res.data;
              if(this.prod.video) this.closeProgressToast();
              else this.$store.commit('setLoading', false);
              this.$store.commit('openModal', {
                type: 'modal-product-reg',
                value: {product_id: res.data, package: prod.package},
                background: true,
                width: 360,
              })
              /* this.toast('저장되었습니다.');
              if(this.getPath(this.$route.path).indexOf('delivery/product/create')>-1) {
                this.$router.replace(this.getPath('delivery/product'));
              }
              else {
                this.$router.replace(this.getPath('product'));
              } */
              this.saveServiceGuide('product')
            }
          }).catch(error=>{
            this.enableButton = true;
            if(this.prod.video) this.closeProgressToast();
            else this.$store.commit('setLoading', false);
            if (error.response) {
              if(error.response.data.message) this.toast(error.response.data.message);
              else this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
            }
          });
        }
      },
      /*partner() {
        return {
          value: this.prodInfo.partner_id,
          label: find(this.partners, 'value', this.prodInfo.partner_id).label
        }
      },*/
      calcPrice() {
        // 할인
        if (this.prod_price.discount_type === 0)
          this.prod_price.saleDiscount = parseInt(this.prod_price.price) - (this.prod_price.price * parseFloat(this.prod_price.discount_rate) / 100);
        else if(this.prod_price.discount_type === 1)
          this.prod_price.saleDiscount = parseInt(this.prod_price.price) - parseInt(this.prod_price.discount_price);

        // 수수료
        if (this.prod_price.comm_type === 0)
          this.prod_price.saleComm = parseInt(this.prod_price.price) * parseFloat(this.prod_price.comm_rate) / 100;
        else if(this.prod_price.comm_type === 1)
          this.prod_price.saleComm = parseInt(this.prod_price.comm_price);

        // 포인트
        if (this.prod_price.point_type === 0)
          this.prod_price.salePoint = parseInt(this.prod_price.price) * parseFloat(this.prod_price.point_rate) / 100;
        else if(this.prod_price.point_type === 1)
          this.prod_price.salePoint = parseInt(this.prod_price.point);

      },
      paramAllList(){
        // 파라미터 리스트
        this.$axios.get(this.getUrl('product/param')).then(res=>{
          if(res.status===200){
            this.param_list = res.data;

            let result = this.paramChecker(this.param_list, this.prod_param)
            if(result.length > 0) this.prod_param = this.prod_param.concat(result);
          }
        })
      },
      async getData(){
        // 파트너 검색 드롭다운 데이터 가져오기
        if(['admin','supervisor'].indexOf(this.$store.getters.mode)>-1) {
          this.$axios.get(this.getUrl('partner/simple')).then(res => {
            this.partners = res.data;
          })
        }

        // 서비스 정보에 기본으로 선택된 패키지 가져오기
        let res = await this.$axios.get('public/service/setting/product');
        if (res.status === 200) {
          this.basic_package = res.data.basic_package;
        }
        let settings = await this.$axios.get('public/service/package_setting');
        if (settings.status === 200) {
          if (settings.data.length === 0) {
            await this.$axios.get('admin/service/package_setting/init');
            settings = await this.$axios.get('public/service/package_setting');
          }
          this.packageSettings = settings.data;
        }
        if(this.$route.query.id) {
          // 상품 상세 가져오기
          this.$axios.get(this.getUrl('product/' + this.$route.query.id))
            .then(res => {
              if (res.status === 200) {
                this.prod = res.data.product;
                this.$store.commit('setProdPackage', this.prod.package);
                this.prod_price = res.data.price;
                if (this.prod_price.end_date.indexOf('9999-01-01') > -1) {
                  this.prod_price.end_date = '';
                }
                this.prod_seo = res.data.seo;
                this.partner_id = res.data.product.partner;
                this.prod_param = res.data.params;
                this.performance = res.data.performance;
                this.conversion = res.data.conversion;
                this.reservePolicy = res.data.reserve_policy;
                this.originReservePolicy = this.cloneItem(this.reservePolicy);
                this.reservePrice = res.data.reserve_price;

                this.selectors = res.data.selectors.map(i => {
                  i.options.forEach(opt => { opt.add = 0; });
                  return i;
                });
                this.selectorStocks = res.data.selector_stocks;

                /* 마스터 백오피스일 경우만 */
                // if(res.data.option){
                //   this.option = res.data.option
                // }

                if(!res.data.product.address){
                  this.prod.address = {
                    sido: '',
                    sigungu: '',
                    dong: '',
                    detail: '',
                    post_code: '',
                    old: '',
                    new: ''
                  }
                }

                for(let i=0; i<res.data.params.length; i++){
                  if(res.data.params[i].param_type===5 && !res.data.params[i].value_address){
                    res.data.params[i].value_address = {
                      sido: '',
                      sigungu: '',
                      dong: '',
                      detail: '',
                      post_code: '',
                      old: '',
                      new: ''
                    }
                  }
                }

                if(!this.prod.tags){
                  this.prod.tags = [];
                }

                this.paramAllList();
                this.getPackages();
                this.$refs.productPrice.getRemains();
                this.getCalculatePrice();
                if (res.data.product_day_price) {
                  this.product_day_price = res.data.product_day_price;
                }
                this.productSituation();
              }
              else {
                // console.log('res')
              }
            })
            .catch(err => {
              // console.log(err)
            })
        }
        else {
          this.paramAllList();
          this.getPackages();
          this.getProdInfoForm();
          this.getProductSetting();
        }

      },
      // Store에 저장되있는 팩 목록 가져오기
      async getPackages(){
        // 카테고리 가져오기
        let cat_res = await this.$axios.get(this.getUrl('category'));
        this.categories = cat_res.data;

        this.packages = this.$store.getters.getPackages.filter(i => i.name !== 'space');
        this.orderConversionArr = this.packages.map(i => {
          return {
            label: i.name,
            value: i.id
          }
        });

        let selectedPack = this.packages.find(i => i.name === this.prod.package);
        if(!selectedPack) {
          selectedPack = this.packages[0];
        }
        this.selectPackage(selectedPack);
      },
      // 팩목록과 비교해서 선택된 팩을 다시 저장
      selectPackage(pack){
        this.changeConversionList(pack);
        this.selectedPack = pack;
        this.prod.package = pack.name;
      },
      // 주문 전환 목록
      changeConversionList(pack) {
        this.order_conversion_arr = [
          { label:'없음', value:0 },
          { label: pack.kor_name, value: pack.id }
        ];
        if(pack.name !== this.prod.package) {
          let setting = this.packageSettings.filter(item=>{ return item.package === pack.name })[0];
          if (setting) {
            this.prod.order_conversion_type = setting.order_conversion_type;
            this.prod.inquiry_conversion_type = setting.inquiry_conversion_type;
            this.prod.payment_type = setting.payment_type;
          }
        }
        // 숙박예약
        if (['reservation', 'booking'].indexOf(pack.name)>-1) {
          // 예약 승인 방식 기본값 '결제 즉시 예약확정'으로 지정
          if(this.prod.auto_resv_status === undefined) {
            this.prod.auto_resv_status = true;
          }
          // reservation 팩일때, 기본 모집인원 10, 무한대 체크 해제 상태로 변경
          if(pack.name === 'reservation') {
            this.prod.stock = 10;
            this.prod.stock_type = 0;
          }
        }

        // 모임참여
        if(pack.name==='meet'){
          this.prod.enable_meet = true;
          this.$axios.get('public/meet/form/simple').then(res=>{
            this.meetFormArr = res.data;
          })
        }

        // 상담신청
        else if(pack.name==='counsel'){
          this.prod.enable_counsel = true;

          this.$axios.get('public/counsel/form/simple').then(res=>{
            this.counselFormArr = res.data;
          })
        }
      },
      onUploadFile(evt) {
        // console.log(evt.target);
        this.prodFile.file = evt.target.files[0];
        let formData = new FormData();
        formData.append('f', this.prodFile.file)
        this.$axios.post('admin/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })
          .then(res => {
            // console.log('uploaded');
            this.prodFile.url = res.data.url;
          });
      },

      onRemoveFileButtonClicked(idx) {
        this.prod.files.splice(idx, 1);
      },

      // 입고수량 재고 수량에 추가하기
      addStock() {
        this.prod.add = parseInt(this.prod.add ? this.prod.add : 0) + parseInt(this.addCount);
        if(this.stockCount === 0) {
          this.stockCount = this.prod.stock;
        }
        this.prod.stock = this.stockCount + this.prod.add;
        this.addCount = 0;
      },

      // 옵션 팝업 꺼질때
      closeOption() {
        this.selectorStocks = [];

        /*if(this.prod.order_conversion_type === 10 || this.prod.order_conversion_type === 11) {
          // this.selectorStocks = this.selectors;
          // 속성 옵션
          let propOptions = findArray(this.selectors, 'option_type', 0);
          if(propOptions.length>0) {
            this.opt([], propOptions, 0);
          }

          // 추가 옵션
          let addOptions = findArray(this.selectors, 'option_type', 1);
          // console.log(addOptions)
          this.selectorStocks = this.selectorStocks.concat(addOptions)
          /!*for(let i=0; i<addOptions.length; i++) {
            for(let j=0; j<addOptions[i].options.length; j++) {
              let item = addOptions[i].options[j];
              this.selectorStocks.push({
                option_type: 1,
                options: [item],
                name: item.name,
                price: item.price,
                enable_stock: false,
                add: 0,
                stock: 0,
                ordered_count: 0,
                addCount: 0,
                stockCount: 0,
              });
            }
          }*!/


        }
        else*/ {
          // 속성 옵션
          let propOptions = findArray(this.selectors, 'option_type', 0);
          if(propOptions.length>0) {
            this.opt([], propOptions, 0);
          }

          // 추가 옵션
          let addOptions = findArray(this.selectors, 'option_type', 1);
          for(let i=0; i<addOptions.length; i++) {
            for(let j=0; j<addOptions[i].options.length; j++) {
              let item = addOptions[i].options[j];
              this.selectorStocks.push({
                option_type: 1,
                options: [item],
                name: item.name,
                price: item.price,
                enable_stock: false,
                add: 0,
                stock: 0,
                ordered_count: 0,
                addCount: 0,
                stockCount: 0,
              });
            }
          }
          /*if(this.$route.query.id) {
            this.$axios.post(this.getUrl(`product/${this.$route.query.id}/selector_stocks`), {stocks: this.selectorStocks})
              .then( res => {
                this.selectorStocks = res.data.stocks;
              });
          }*/
        }
        //this.$modal.hide('optionModal');
      },
      opt(str, all, cur) {
        for(let i=0; i<all[cur].options.length; i++) {
          let item = all[cur].options[i];
          let arr = this.cloneItem(str);
          arr.push(item);
          if(cur === all.length-1) {
            let name = '';
            let price = 0;
            arr.forEach(arr_item => {
              if(name !== '') name += ' x ';
              name += arr_item.name;
              price += parseInt(arr_item.price);
            });
            this.selectorStocks.push({
              option_type: 0,
              options: arr,
              name: name,
              price: price,
              enable_stock: false,
              add: 0,
              stock: 0,
              ordered_count: 0,
              addCount: 0,
              stockCount: 0,
            });
          } else {
            // 재귀호출
            this.opt(arr, all, cur+1);
          }
        }
      },
      periodDateText(date) {
        return date>1 ? `${date-1}박 ${date}일` : `무박 ${date}일`;
      },
      productSituation() {
        // 0: 판매중, 1: 품절, 2: 마감
        // 상품 판매 사용
        if(this.prod.enable_prod) {
          // 상품 판매 날짜가 있을 경우
          if(this.prod_price.start_date && this.prod_price.end_date){
            let isBool1 = moment(this.prod_price.start_date).isBefore(moment());
            let isBool2 = moment(this.prod_price.end_date).isAfter(moment());
            if( isBool1 && isBool2 ){
              this.prod.sale_status = 0;
            }
            else this.prod.sale_status = 2;
          }
          // 재고 없을 경우
          else if(this.prod.stock_type===0 && this.prod.stock===0) this.prod.sale_status = 1;
          // 날짜 선택 안했을 경우
          else if(!this.prod_price.start_date && !this.prod_price.end_date){
            return this.prod.sale_status = 0;
          }
          else return this.prod.sale_status = 2;
        }
        // 상품 판매 사용안함
        else {
          return '마감';
        }
      },
      showCommonInfo(type) {
        if(!this.selectedPack) {
          return false;
        }
        let enable = false
        // 배송안내 표시
        if(type==='enable_delivery_info') {
          if (['mart', 'delivery'].indexOf(this.selectedPack.name) > -1) {
            enable = true;
          }
        }
        // 교환 및 반품안내 표시
        if(type==='enable_refund_info') {
          if (['mart', 'delivery'].indexOf(this.selectedPack.name) > -1) {
            enable = true;
          }
        }
        return enable;
      },
      // 상품 종류 선택에 따른 해당 카테고리 재구성
      mapCat(i) {
        return {
          value: i.id,
          label: i.name,
          packages: i.packages,
          parent: i.parent_id
        }
      },
      initCategories(){
        let catArr1 = this.categories.filter(i => i.packages.indexOf('all') > -1 || i.packages.indexOf(this.selectedPack.name)>-1);
        this.catArr1 = catArr1.map(i => this.mapCat(i));
        let catArr2 = catArr1.reduce((a,c) => a.concat(c.child), []);
        this.catArr2 = catArr2.map(i => this.mapCat(i));
        this.catArr3 = catArr2.reduce((a,c) => a.concat(c.child), []).map(i => this.mapCat(i));

        if(!this.catArr1.some(i => i.value === this.prod.category1_id)) {
          this.prod.category1_id = '';
          this.prod.category2_id = '';
          this.prod.category3_id = '';
        }

        this.cat2 = this.get_cat(this.catArr2, this.prod.category1_id);
        this.cat3 = this.get_cat(this.catArr3, this.prod.category2_id);
      },
      initCustomCommonInfo() {
        if (this.selectedPack) {
          if (['reservation', 'booking', 'meet'].indexOf(this.selectedPack.name) > -1) {
            this.custom_common_info_arr = [
              {label: '유의사항', key:'enable_use_info', value: 'use_info'},
              {label: '취소/환불 안내',key:'enable_refund_info', value: 'refund_info'}]
          } else if (['mart', 'delivery'].indexOf(this.selectedPack.name) > -1) {
            this.custom_common_info_arr = [
              {label: '상품 정보 제공 고시',key:'enable_use_info', value: 'use_info'},
              {label: '배송안내',key:'enable_delivery_info',value: 'delivery_info'},
              {label: '교환 및 반품안내',key:'enable_refund_info', value: 'refund_info'}];
          } else if (['call'].indexOf(this.selectedPack.name) > -1) {
            this.custom_common_info_arr = [
              {label: '상품 정보 제공 고시',key:'enable_use_info', value: 'use_info'},
              {label: '배송안내',key:'enable_delivery_info',value: 'delivery_info'}];
          } else {
            this.custom_common_info_arr = [{label: '상품 정보 제공 고시', key:'enable_use_info', value: 'use_info'}];
          }
        }
      },
      modifyCategory() {
        let url = `/office/admin/category/create`;
        this.$router.replace(url);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
  .product-short-input
    width 89px

  .lp-reg-category-box
    width 100%
    display flex

  .lp-reg-category
    border-radius 3px
    border 1px solid $warmgrey
    color $font
    margin-right 20px
    width calc(33% - 12px)
    height fit-content

  .lp-reg-category:last-child
  .lp-reg-category-un:last-child
    margin-right 0

  .lp-reg-category div
  .lp-reg-category-un div
    padding 8px
    text-align center
    font-size 0.9rem
    cursor pointer

  .lp-reg-category div
    border-bottom 1px solid $warmgrey

  .lp-reg-category div:last-child
    border-bottom 0
  .lp-reg-category div:hover
    background $warmgrey

  .lp-reg-category div.select
    background $primary
    color white

  .lp-reg-category-un
    border-radius 3px
    border 1px solid $warmgrey
    color $font
    width calc(33% - 10px)
    height fit-content
    margin-right 20px

  .lp-reg-category-un div
    border-bottom 1px solid $primary

  .lp-reg-category-un div:last-child
    border-bottom 0

  .lp-reg-category div.selected
    background $primary
    color white

  .lp-tab
    display flex
    padding 10px 24px
    color #555

  .lp-tab-selected
    border: 1px solid #ccc;
    border-bottom: 1px solid #fff;
    color: #555;
    border-radius: 3px;

  .service-conversion-info
    display flex
    justify-content space-evenly
    max-width 50%
    min-width 50%
    padding 4px 8px

  .service-conversion-info-label
    display inline-block
    width 112px
    min-width 80px
    margin 0

  .prod-reg-content
    margin-top 12px

  .lp-txt-period
    font-size 12px
    text-align center
    width 90px
    color #989898

  .box-disabled
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background-color rgba(255,255,255,0.4)
    z-index 100

  :target
    top -130px
    display block
    position relative
    visibility hidden

  .level-title
    font-size 1.4rem

  .fixed
    background-color white
    position fixed
    border 1px solid #dddddd
    width calc(100% - 400px)
    left 400px
    top 49px
    z-index: 999
    padding 12px 20px

  .modify-btn
    width 76px
    gap 0 4px
    background-color rgba(255, 206, 166, 0.3)
    border none !important
    border-radius 50px

  .common-info
    margin-bottom 20px
</style>
